export const ENCODING = {
    QUOTED_PRINTABLE: 'quoted-printable',
    URI: 'uri',
    INTEGER: 'integer',
    FLOAT: 'float',
    BOOLEAN: 'boolean',
    DATE_TIME: 'date-time',
    TIMESTAMP: 'timestamp',
    DATE: 'date',
    TIME: 'time',
    UTC_OFFSET: 'utc-offset',
};

export const TYPE = {
    WORK: 'work',
    HOME: 'home',
};

export const VERSION = '3.0';
export const FN = 'fn';
export const N = 'n';
export const NICKNAME = 'nickname';
export const PHOTO = 'photo';
export const BDAY = 'bday';
export const ADR = 'adr';
export const LABEL = 'label';
export const TEL = 'tel';
export const EMAIL = 'email';
export const MAILER = 'mailer';
export const TZ = 'tz';
export const GEO = 'geo';
export const TITLE = 'title';
export const ROLE = 'role';
export const LOGO = 'logo';
export const AGENT = 'agent';
export const ORG = 'org';
export const CATEGORIES = 'categories';
export const NOTE = 'note';
export const PRODID = 'prodid';
export const REV = 'rev';
export const SORT_STRING = 'sort-string';
export const SOUND = 'sound';
export const UID = 'uid';
export const URL = 'url';
export const CLASS = 'class';
export const KEY = 'key';

export const VERSION_PROP = 'VERSION';
export const BEGIN_VCARD = 'BEGIN:VCARD';
export const END_VCARD = 'END:VCARD';